import httpManager from "@/app/shared/utils/httpManager";

export default async function (params) {
  let query = "?";
  query += params.query.startValue ? `start_date=${params.query.startValue} 00:00:00&` : "";
  query += params.query.endValue ? `end_date=${params.query.endValue} 23:59:59&` : "";
  query += params.query.portfolio ? `portfolio=${params.query.portfolio}&` : "";
  query += params.query.entity ? `entity=${params.query.entity}&` : "";
  const url = `/reports/${params.query.type}/${query}`;
  const response = await httpManager.get(url);
  return response?.data;
}
